import { FunctionComponent, ReactNode } from 'react'
import { SportsHeaderContextType } from '@contexts/sportsHeader'
import { LiveEventDataSportTypes } from '@utils/formatters/liveEvent'
import useSportsEvent from '@hooks/useSportsEvent'
import { TOITeaserAPIProps } from '../toi/types'
import Formula1Header from './SportsHeaderFormula1'
import HockeyHeader from './SportsHeaderHockey'
import SkiHeader from './SportsHeaderSki'
import SoccerHeader from './SportsHeaderSoccer'
import TennisHeader from './SportsHeaderTennis'
import SportsHeaderComponents from '@components/Teaser/SportsHeader'
import SportsHeaderContextProvider from './SportsHeaderContextProvider'

interface SportsHeaderProps
  extends Required<Pick<TOITeaserAPIProps, 'matchId' | 'typeOfSport'>>,
    Pick<SportsHeaderContextType, 'teaserFlex' | 'teaserType'> {
  children?: ReactNode
}

const { SportsExtraContentWrapper, SportsHeaderWrapper } =
  SportsHeaderComponents

const SportsHeader: FunctionComponent<SportsHeaderProps> = ({
  matchId,
  typeOfSport,
  teaserFlex,
  teaserType,
  children,
}) => {
  const { data: sportsEventData } = useSportsEvent({ matchId, typeOfSport })

  let SportsHeaderComponent

  switch (sportsEventData?.sportsEventType) {
    case LiveEventDataSportTypes.FORMULA1:
      if (teaserType !== 'toi') {
        SportsHeaderComponent = null
      } else {
        SportsHeaderComponent = (
          <Formula1Header data={sportsEventData.formattedData} />
        )
      }
      break
    case LiveEventDataSportTypes.HOCKEY:
      SportsHeaderComponent = (
        <HockeyHeader data={sportsEventData.formattedData} />
      )
      break
    case LiveEventDataSportTypes.SKI:
      if (teaserType !== 'toi') {
        SportsHeaderComponent = null
      } else {
        SportsHeaderComponent = (
          <SkiHeader data={sportsEventData.formattedData} />
        )
      }
      break
    case LiveEventDataSportTypes.SOCCER:
      SportsHeaderComponent = (
        <SoccerHeader data={sportsEventData.formattedData} />
      )
      break
    case LiveEventDataSportTypes.TENNIS:
      if (teaserType !== 'toi') {
        SportsHeaderComponent = null
      } else {
        SportsHeaderComponent = (
          <TennisHeader data={sportsEventData.formattedData} />
        )
      }
      break
    default:
      SportsHeaderComponent = null
      break
  }

  return (
    <SportsHeaderContextProvider
      teaserFlex={teaserFlex}
      teaserType={teaserType}>
      <SportsHeaderWrapper>
        {SportsHeaderComponent}
        {teaserType === 'toi' && (
          <SportsExtraContentWrapper>{children}</SportsExtraContentWrapper>
        )}
      </SportsHeaderWrapper>
    </SportsHeaderContextProvider>
  )
}

export default SportsHeader
